import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { REPLACE_AIR } from "../../replace_str_constant";
import { useDispatch, useSelector } from "react-redux";
import {
  clearGameLink,
  startGameLoading,
  storeGameConfig,
} from "../../redux/action/game/gameAction";
import LazyImage from "../Loading/lazyImage";
import LoadingLine from "../Loading/LoadingLine";
import { COMMON_WEB_PATH, COMMON_WEB_PATH_JP } from "../../constant";
import useDeviceType from "../../hook/useDeviceType";
import { useTranslation } from "react-i18next";
import { CloseMenu, globalTrigger, notice } from "../../redux/action/action";
import { languageTransfer } from "../../utils/languageTransfer";
import i18next from "i18next";
import { BsTools } from "react-icons/bs";
import { BiSolidTag } from "react-icons/bi";
import Cookies from "js-cookie";
import {
  AbsoluteCenter,
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Skeleton,
  Text,
  Tooltip,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { RiUser3Fill } from "react-icons/ri";
import useCheckLogin from "../../hook/useCheckLogin";
import { thisImageNeedDark } from "../../utils/thisImageNeedDark";
import useSound from "../../hook/useSound";
import GameTag from "./gameTag";
import GameImageTag from "./GameImageTag";
import TooltipWithTouch from "../Common/TooltipWithTouch";
import ToggleFavorite from "../Favorite/toggleFavorite";
import useGames from "../../pages/Game/useGames";

const GameItem = ({
  originProps,
  gameProps,
  specMask,
  isHot,
  isHighlight,
  isNew,
  itemIndex,
  forceShow,
  fullImageLayout, // 是否使用全圖模式
  liveLayout,
  customHeight,
  hideGameName,
  customSubType,
  onCloseFunction = () => {},
}) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const { gameCode, platform, gameName, gameSubType } = gameProps;
  //遊戲ITEM的資料
  const { gameNameEn, game_tags, game_subtype } = originProps;
  const isMobile = useDeviceType() === "Mobile";

  const { isLobby, isLiveLayoutOpen, showLogoInCenter } = liveLayout || {};

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const onlinePlayer = useSelector((state) => state.isGameOnlinePlayer);
  const { game } = onlinePlayer || {};

  const textColor = useColorModeValue("dark.100", "light.100");
  const itemBg = useColorModeValue("light.100", "dark.250");
  const textBgColor = useColorModeValue("light.200", "dark.100");

  const { isLogin, isMachineUser } = useCheckLogin();

  const playButtonSound = useSound(); // 進遊戲按鈕音效
  const hoverButtonSound = useSound({
    customSound: "slide_sound",
    volume: 0.3,
  });

  const { allGamePlatform = [] } = isHandleAllGame;

  const { isOpen, onOpen, onToggle, onClose } = useDisclosure();

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  const getPrevPath = useMemo(() => {
    const path = location.pathname.split("/");
    const currentPathIndex = path.findIndex((item) => item === "game-confirm");

    if (currentPathIndex === -1) return "";

    return `${path.slice(0, currentPathIndex).join("/")}/`;
  }, [location.pathname]);

  const currentPlayer = useMemo(() => {
    return game?.[originProps.gameUid] || 0;
  }, [game]);

  const getPlatformIsMaintain = useMemo(() => {
    const findPlatform = allGamePlatform.find(
      (item) => item.platform === platform,
    );
    /**
     * @param temp_maintenance_end_time  暫時維護結束時間
     * @param temp_maintenance_start_time 暫時維護開始時間
     * @param maintenanceStartTime  維護開始時間
     * @param maintenanceEndTime    維護結束時間
     * NOTE : 如果有暫時維護時間，則使用暫時維護時間，否則使用正式維護時間
     */
    const {
      temp_maintenance_end_time,
      temp_maintenance_start_time,
      maintenanceStartTime,
      maintenanceEndTime,
    } = findPlatform || {};
    const isMaintain = findPlatform?.isUnderMaintenance;
    if (isMaintain) {
      return {
        state: true,
        component: (
          <TooltipWithTouch
            label={
              <Flex
                direction={"column"}
                alignItems={"center"}
                justifyContent={"center"}
                fontWeight={"500"}
              >
                <Text as="span">
                  {temp_maintenance_start_time || maintenanceStartTime}
                </Text>
                <Text as="span">~</Text>
                <Text as="span">
                  {temp_maintenance_end_time || maintenanceEndTime}
                </Text>
              </Flex>
            }
          >
            <Box
              borderRadius={{
                base: "10px",
                md: "15px",
                xl: "20px",
              }}
              bg="rgba(0,0,0,0.7)"
              position="absolute"
              top="0"
              left="0"
              w="100%"
              h="100%"
              zIndex="3"
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection={"column"}
              gap="10px"
              color="white"
            >
              <Icon as={BsTools} fontSize="30px" />
              <Flex
                direction={"column"}
                alignItems={"center"}
                justifyContent={"center"}
                fontSize="sm"
                fontWeight={"500"}
              >
                <Text as="span">{i18n_common("platformMaintain")}</Text>
              </Flex>
            </Box>{" "}
          </TooltipWithTouch>
        ),
      };
    }
  }, [platform, allGamePlatform]);

  const { handlePlayGame } = useGames();

  const handleEnterGame = () => {
    // 播放按鈕音效
    playButtonSound();

    if (getPlatformIsMaintain?.state) return;
    dispatch(storeGameConfig(originProps));
    dispatch(clearGameLink());
    dispatch(CloseMenu());
    dispatch(startGameLoading());

    const game_name = gameNameEn.replace(/ /g, "-");
    const game_platform = originProps.game_platform.replace(/ /g, "-");

    handlePlayGame({
      gameName: game_name,
      gamePlatform: game_platform,
      gameUid: originProps.gameUid,
    });

    // 進入遊戲後呼叫關閉回呼
    onCloseFunction();
  };


  return (
    <Box role="group" position={`relative`}>
      {!isMachineUser && ( //機台使用者不顯示
        <Box>
          <ToggleFavorite
            customGameUid={originProps?.gameUid}
            fontSize={"15px"}
            wrapperClass={{
              w: "30px",
              h: "30px",
              border: "2px solid",
              borderColor: "#3e5dfd",
              bg: "linear-gradient(to bottom, #0edcff, #3f38ff)",
              zIndex: 3,
              position: "absolute",
              top: "0px",
              right: "0px",
              borderRadius: `full`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          />
        </Box>
      )}
      <Flex
        role="group"
        direction={`column`}
        position={`relative`}
        cursor={
          getPlatformIsMaintain?.state && !forceShow ? `not-allowed` : `pointer`
        }
        px={{
          base: isHot ? "" : "10px",
          md: "10px",
        }}
        py={{
          base: isHot ? "" : "10px",
          md: "10px",
        }}
        // onClick={isMobile ? () => false : handleEnterGame}
        onClick={handleEnterGame}
        onMouseEnter={isMobile ? () => false : hoverButtonSound}
        boxShadow={`base`}
        my="2px"
        hover={{
          background: {
            md: getPlatformIsMaintain?.state
              ? `none`
              : specMask
                ? `rgba(0,0,0,0.1)`
                : `brand.500`,
          },
        }}
        p={(isHot || isLiveLayoutOpen) && itemIndex + 1 < 11 ? "" : ""}
      >
        <GameImageTag game_tags_props={game_tags || []} />

        <Box
          position="absolute"
          w="100%"
          h="100%"
          top="0px"
          left="0px"
          bgImage={`url('${COMMON_WEB_PATH}/911TW/blingBorder.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          zIndex={2}
          pointerEvents="none"
        />
        <Box
          position={"absolute"}
          w="100%"
          h="100%"
          top="0px"
          left="0px"
          // bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/game_BFrame2x.webp')`}
          bgImage={
            hideGameName
              ? `url('${COMMON_WEB_PATH}/FlyDragon/game_BFrame_mobile.webp')`
              : {
                  base: `url('${COMMON_WEB_PATH}/911TW/gameitemBG.webp')`,
                  sm: `url('${COMMON_WEB_PATH}/911TW/gameitemBG.webp')`, // sm 以上使用的圖片
                }
          }
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
          zIndex={1}
          onClick={handleEnterGame}
          cursor={"pointer"}
          _groupHover={{
            // bgImage: `url('${COMMON_WEB_PATH}/FlyDragon/game_BFrame2x_active4.png?123123')`,
            bgImage: getPlatformIsMaintain?.state
              ? hideGameName
                ? `url('${COMMON_WEB_PATH}/FlyDragon/game_BFrame_mobile.webp')`
                : {
                    base: `url('${COMMON_WEB_PATH}/FlyDragon/game_BFrame2x_mobile2.webp')`,
                    sm: `url('${COMMON_WEB_PATH}/FlyDragon/game_BFrame2x.webp')`, // sm 以上使用的圖片
                  }
              : `url('${COMMON_WEB_PATH}/911TW/gameitemBG.webp')`,
            borderRadius: "common",
          }}
          display={"flex"}
          alignItems={"flex-end"}
          justifyContent={"center"}
          pb="2vw"
        >
          {/* {!hideGameName && (
            <>
              <Text
                display={{
                  base: "block",
                  sm: "none",
                }}
                mb="0px"
                px="5px"
                textAlign={`left`}
                width={`100%`}
                maxW="100%"
                fontWeight={`700`}
                color="white"
                position="absolute"
                bottom="16%"
                left="10%"
                zIndex="4"
                fontSize={{
                  base: "16px",
                  md: "18px",
                }}
                isTruncated // Chakra UI的內建屬性 會自動處理省略號
                // _groupHover={{
                //   display: "none",
                // }}
              >
                {gameNameEn}
              </Text>
              <Text
                display={{
                  base: "block",
                  sm: "none",
                }}
                mb="0px"
                px="5px"
                textAlign={`left`}
                width={`100%`}
                maxW="100%"
                fontWeight={`700`}
                color="#e2abff"
                position="absolute"
                bottom="10%"
                left="10%"
                zIndex="4"
                fontSize={{
                  base: "12px",
                  md: "12px",
                }}
                opacity={0.8}
                isTruncated // Chakra UI的內建屬性 會自動處理省略號
              >
                {game_subtype}
              </Text>
            </>
          )} */}
        </Box>

        <Box borderRadius={`sm`} overflow="hidden">
          {showLogoInCenter ? (
            <>
              <Box
                position="absolute"
                bg="rgba(0,0,0,0.7)"
                w="100%"
                h="100%"
                top="0px"
                left="0px"
                zIndex={1}
              ></Box>
              <AbsoluteCenter top="40%" zIndex={2}>
                <Image
                  src={`${COMMON_WEB_PATH}/ds88platformIcon/${thisImageNeedDark(
                    platform,
                    true,
                  )}.png`}
                  w="140px"
                  transform={"scale(1.3)"}
                />
              </AbsoluteCenter>
            </>
          ) : null}
          {currentPlayer > 0 && (
            <Box
              position="absolute"
              right="5px"
              top="5px"
              borderRadius={`full`}
              py="3px"
              px="10px"
              zIndex={2}
              bg={itemBg}
              color={textColor}
              display="flex"
              alignItems={`center`}
              gap="3px"
              fontSize="12px"
            >
              <Icon as={RiUser3Fill} />
              {currentPlayer}
            </Box>
          )}
          {getPlatformIsMaintain?.component}
          <Box
            pt={
              customHeight
                ? customHeight
                : {
                    base: fullImageLayout ? "110%" : "100%",
                    // 105 120
                    md: fullImageLayout ? "150%" : "100%",
                  }
            }
            position="relative"
            borderRadius={`8px`}
            overflow="hidden"
          >
            <Box
              p="10px"
              zIndex={2}
              position="absolute"
              top="0px"
              left="0px"
              height="100%"
              width="100%"
              // overflow="hidden"
              isolation={`isolate`}
              borderRadius={`common`}
            >
              {" "}
              <Box
                position="absolute"
                top="5px"
                left="5px"
                right="5px"
                bottom="5px"
                height={
                  hideGameName
                    ? "calc(100% - 10px)"
                    : {
                        base: "calc(100% - 10px)",
                        sm: "calc(100% - 10px)",
                      }
                }
                width="calc(100% - 10px)"
                // overflow="hidden"
              >
                <LazyImage
                  //預設嘗試載入gif  如果gif不存在或載入失敗，自動切換到 webp
                  src={`${COMMON_WEB_PATH_JP}/game-icon-ds88/${
                    i18next.language
                  }/${platform}/${REPLACE_AIR(gameCode)}.gif`}
                  alt={gameNameEn}
                  closeInverted
                  className={`w-full h-full ${
                    fullImageLayout ? "rounded-[12px]" : "rounded-[12px]"
                  }`}
                  onError={(e) => {
                    const img = e.target;
                    const currentSrc = img.src;
                    const lang = i18next.language;
                    const gameCodeReplaced = REPLACE_AIR(gameCode);

                    if (
                      lang !== "en" &&
                      currentSrc.endsWith(
                        `${lang}/${platform}/${gameCodeReplaced}.gif`,
                      )
                    ) {
                      img.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/${lang}/${platform}/${gameCodeReplaced}.webp`;
                    } else if (
                      lang !== "en" &&
                      currentSrc.endsWith(
                        `${lang}/${platform}/${gameCodeReplaced}.webp`,
                      )
                    ) {
                      img.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${gameCodeReplaced}.gif`;
                    } else if (
                      currentSrc.endsWith(
                        `en/${platform}/${gameCodeReplaced}.gif`,
                      )
                    ) {
                      img.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${gameCodeReplaced}.webp`;
                    } else {
                      img.onerror = null;
                    }
                  }}
                />
              </Box>
              <Box
                position={`absolute`}
                top="0px"
                left="0px"
                height="100%"
                width="100%"
                borderRadius={`common`}
                display={{
                  base: "none",
                  md: "flex",
                }}
                alignItems={`center`}
                justifyContent={`center`}
                opacity={0}
                className="transition duration-300"
                _groupHover={{
                  opacity: 1,
                }}
                bg={specMask ? "rgba(0,0,0,0.6)" : "game-item.mask"}
              >
                <Image
                  onClick={handleEnterGame}
                  cursor={"pointer"}
                  src={`${COMMON_WEB_PATH}/911TW/playBTN.webp`}
                  w="60%"
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default React.memo(GameItem);
